<template>
  <span
    :class="tagClasses"
    :role="clickable ? 'button' : undefined"
    :tabindex="clickable ? 0 : undefined"
    @click="handleClick"
    @keydown.enter.prevent="handleClick"
    @keydown.space.prevent="handleClick"
  >
    <span class="ui-tag__label">
      <slot>{{ label }}</slot>
    </span>
    <button
      v-if="removable"
      type="button"
      class="ui-tag__remove"
      aria-label="Remove tag"
      @click.stop="emit('remove')"
    >
      <i class="material-icons">close</i>
    </button>
  </span>
</template>

<script setup lang="ts">
import { computed } from 'vue';

type TagTone = 'neutral' | 'primary' | 'success' | 'danger';
type TagSize = 'sm' | 'md';

const props = withDefaults(defineProps<{
  label?: string;
  tone?: TagTone;
  size?: TagSize;
  clickable?: boolean;
  removable?: boolean;
}>(), {
  label: '',
  tone: 'neutral',
  size: 'md',
  clickable: false,
  removable: false
});

const emit = defineEmits<{
  click: [];
  remove: [];
}>();

const tagClasses = computed(() => [
  'ui-tag',
  `ui-tag--${props.tone}`,
  `ui-tag--${props.size}`,
  {
    'is-clickable': props.clickable,
    'is-removable': props.removable
  }
]);

function handleClick(): void {
  if (!props.clickable) {
    return;
  }

  emit('click');
}
</script>